module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am189-6eccb80ec65ceed63f5bb06cc0eed7ea.jpg";